import axios from 'axios';
import '../assets/lib/jquery.min.js'

const Storage = {}

Storage.get = function(name) {
    return JSON.parse(sessionStorage.getItem(name))
}

Storage.set = function(name, val) {
    sessionStorage.setItem(name, JSON.stringify(val))
}

Storage.add = function(name, addVal) {
    let oldVal = Storage.get(name)
    let newVal = oldVal.concat(addVal)
    Storage.set(name, newVal)
}

var ajax = {
    get: function(url, data, callback, token) {
        var contenttype = "text/plain";
        http({
            method: "get",
            headers: {
                "Content-Type": contenttype,
                "Token": token
            },
            url: url,
            params: data,
        }).then(function(res) {
            httpcallback(res, callback);
        }).catch(function(err) {
            errCallBack(err, callback);
        })
    },
    post: function(url, udata, callback, token) {
        var contenttype = "application/json;charset=utf-8";
        if (typeof(udata) == "string") {
            contenttype = "application/x-www-form-urlencoded;charset=utf-8";
        }
        http({
            method: "post",
            headers: {
                "Content-Type": contenttype,
                "Token": token
            },
            url: url,
            data: udata,
            timeout: 60000,
            responseType: 'text'
        }).then(function(res) {
            httpcallback(res, callback);
        }).catch(function(err) {
            errCallBack(err, callback);
        })
    },
    postForm: function(url, udata, callback, token) {
        http({
            method: "post",
            headers: {
                "Content-Type": "multipart/form-data",
                "Token": token
            },
            url: url,
            data: udata,
            timeout: 600000,
            responseType: 'text'
        }).then(function(res) {
            httpcallback(res, callback);
        }).catch(function(err) {
            errCallBack(err, callback);
        })
    }
}
let httpcallback = function(res, callback) {
    if (res.status == 200) {
        callback(res.data);
        return;
    }
    var err = {
        Ret: -1,
        Msg: '返回状态码' + res.status
    };
    if (res.status == 401) {
        err.Ret = 401;
    }
    callback(err);
}
let errCallBack = function(err, callback) {

    if (err.message.indexOf("timeout") > -1) {
        err.message = "连接超时，请稍后重试。";
    }

    var errdata = {
        Ret: -1,
        Msg: err.message
    };
    if (err.response != undefined && err.response.status == 401) errdata.Ret = 401;
    callback(errdata);
}

let http;
let RegQrcodeUrl = "";
let InsNameCn = "InsNameCn";
let InsNameEn = "InsNameEn";
let SubAccountLimit = "SubAccountLimit";
let HandlingSubAgent = "HandlingSubAgent";
let CertificationUpload = "CertificationUpload";
let AgentFeeTemplatesIsShow = "AgentFeeTemplatesIsShow";
let UseSimpleViewKey = "UseSimpleView";
$.ajax({
    type: "get",
    url: "../../static/config.json",
    async: false,
    success: function(data) {

        let queryurl = data.AgentApiUrl;


        if (data.AgentApiUrl.includes('*')) {

            queryurl = window.location.protocol + '//' + window.location.hostname + data.AgentApiUrl.split("*")[1]
        }

        http = axios.create({
            baseURL: queryurl, //"http://futures.mlinsoft.com:9908/api/", //config.ApiUrl,//'http://192.168.1.205:8000/api/',

            withCredentials: true,
            headers: { 'BrowserHost': window.location.href }
        });

        RegQrcodeUrl = data.RegQrcodeUrl;
        sessionStorage.setItem("RegQrcodeUrl", RegQrcodeUrl);
        var useSimpleView = false;
        if (data.UseSimpleView != null) {
            console.log("加载：" + data.UseSimpleView);
            useSimpleView = Boolean(data.UseSimpleView);

        }
        sessionStorage.setItem("UseSimpleView", useSimpleView);
        sessionStorage.setItem("IsRegister", data.IsRegister);
        Storage.set(InsNameCn, data.InsNameCn);
        Storage.set(InsNameEn, data.InsNameEn);
        Storage.set(SubAccountLimit, data.SubAccountLimit);
        Storage.set(HandlingSubAgent, data.HandlingSubAgent);
        Storage.set(CertificationUpload, data.CertificationUpload);
        Storage.set(AgentFeeTemplatesIsShow, data.AgentFeeTemplatesIsShow);

        //配置模板
        if (data.TemplateSetting !== undefined) {

            sessionStorage.setItem('TemplateSetting', data.TemplateSetting);
        } else {
            sessionStorage.setItem('TemplateSetting', true);
        }
        //配置下级代理
        if (data.LowerAgent !== undefined) {

            sessionStorage.setItem('LowerAgent', data.LowerAgent);
        } else {

            sessionStorage.setItem('LowerAgent', true);
        }
        //子账户
        if (data.SubAccount !== undefined) {

            sessionStorage.setItem('SubAccount', data.SubAccount);
        } else {

            sessionStorage.setItem('SubAccount', true);
        }
        //配置直属账户

        if (data.DirectlyCustomer !== undefined) {

            sessionStorage.setItem('DirectlyCustomer', data.DirectlyCustomer);
        } else {
            sessionStorage.setItem('DirectlyCustomer', true);
        }
        //配置子账户登录
        if (data.SubAccountLogin !== undefined) {

            sessionStorage.setItem('SubAccountLogin', data.SubAccountLogin);
        } else {
            sessionStorage.setItem('SubAccountLogin', true);
        }

        //配置 数据查询==>客户查询==>委托查询结果==>操作
        if (data.DQRTC !== undefined) {

            sessionStorage.setItem('DQRTC', data.DQRTC);
        } else {

            sessionStorage.setItem('DQRTC', true);
        }



    }
});

export default ajax;


// WEBPACK FOOTER //
// ./src/api/index.js